/**
 * Der Konflikt-Banner: erscheint, wenn ein FREMDER Nutzer den Datensatz geaendert hat, den dieser
 * Client gerade geoeffnet hat. Er UEBERSCHREIBT NICHTS - er meldet und laesst den Nutzer
 * entscheiden.
 *
 * NEUE FLAECHE OHNE VORBILD. Der Bestand hat dafuer keine Entsprechung: er setzte die
 * Aktualisierung bei geoeffnetem Datensatz komplett aus (`refreshFromServer()`, `index.html:5916`)
 * und versuchte nach einem 409 zweimal einen Drei-Wege-Merge, bevor er einen roten Balken zeigte
 * ("Bitte Seite neu laden", `index.html:6166-6168`). Beides entfaellt (Spec,
 * "Verhaltensaenderung 1"). Die Flaeche steht deshalb im Ausnahmeregister der Screenshot-Baseline
 * (`test/visual/ausnahmen.ts`, Grund `neue-flaeche-ohne-vorbild`) und wird ueber
 * `test/komponenten/App/konfliktBanner.test.tsx` abgesichert, nicht ueber den Bildvergleich.
 *
 * Zum Aussehen: `bestand.css` bleibt in dieser Phase UNVERAENDERT (Phase-6-Plan, Dateistruktur -
 * "die ~3.620 CSS-Zeilen, unveraendert"). Es gibt dort keine `.konflikt-banner`-Regel und es darf
 * hier auch keine dazukommen. Der Banner traegt deshalb seine eigene Vertragsklasse plus die
 * bestehenden Knopfklassen `btn-sec`/`btn-ghost`; das Gestalten der Flaeche ist ein eigener,
 * benannter Restposten (siehe Task-8-Bericht).
 *
 * `geaendertVon` ist ein ANZEIGENAME, nicht die Nutzer-id. Store und Backend fuehren an dieser
 * Stelle eine id (`event.actor` bzw. `current.updatedBy`, beide ausdruecklich als id begruendet -
 * `backend/src/sse/broadcast.ts`); die Aufloesung zum Namen passiert beim Einhaengen, nicht hier.
 */
export interface KonfliktBannerProps {
  entitaet: string;
  id: string;
  /** Anzeigename des Aendernden - siehe Kopfkommentar. */
  geaendertVon: string;
  onUebernehmen: () => void;
  onVerwerfen: () => void;
}

export function KonfliktBanner({
  entitaet,
  id,
  geaendertVon,
  onUebernehmen,
  onVerwerfen,
}: KonfliktBannerProps) {
  return (
    <div className="konflikt-banner" role="alert">
      {/*
        Der Satz laeuft bewusst in die Beschriftung des ersten Knopfes hinein
        ("... geaendert - neu laden"): die Handlung steht damit im Satz und nicht daneben. Deshalb
        endet dieser Text mit einem Leerzeichen und der Knopf traegt Kleinschreibung.
      */}
      <span className="konflikt-banner-text">
        {`Dieser Datensatz (${entitaet}/${id}) wurde von ${geaendertVon} geändert — `}
      </span>
      <button type="button" className="btn-sec" onClick={onUebernehmen}>
        neu laden
      </button>
      <span className="konflikt-banner-text">{" oder "}</span>
      <button type="button" className="btn-ghost" onClick={onVerwerfen}>
        verwerfen
      </button>
    </div>
  );
}
